import { defineComponent as s, useSlots as p, createBlock as c, openBlock as l, unref as a, mergeProps as f, createSlots as i, withCtx as e, renderSlot as n } from "vue";
import { Tippy as u } from "vue-tippy";
const _ = /* @__PURE__ */ s({
  __name: "STooltip",
  props: {
    content: {}
  },
  setup(m) {
    const o = p(), r = (t) => o[t] && typeof o[t] == "function";
    return (t, d) => (l(), c(a(u), f({ content: t.content }, t.$attrs, { theme: "s-tooltip" }), i({
      default: e(() => [
        n(t.$slots, "default")
      ]),
      _: 2
    }, [
      !t.content && r("content") ? {
        name: "content",
        fn: e(() => [
          n(t.$slots, "content")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["content"]));
  }
});
export {
  _ as default
};
